import { uid } from 'uid';

const UIDHelper = {
	create() {
    return uid(25)
  }
}

export default UIDHelper;